import { render, staticRenderFns } from "./CardsDataSearchResult.vue?vue&type=template&id=1edca42e&scoped=true"
import script from "./CardsDataSearchResult.vue?vue&type=script&lang=js"
export * from "./CardsDataSearchResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edca42e",
  null
  
)

export default component.exports